<template>
    <course-imgs-temp :img-urls="imgUrls"></course-imgs-temp>
</template>

<script>
import CourseImgsTemp from '@/components/puppetComponent/CourseImgsTemp'
export default {
  data () {
    return {
      imgUrls: [
        '/upaiyun/Sys/20190603/4859920077929690768.png',
        '/upaiyun/Sys/20190603/5516072785259940484.png',
        '/upaiyun/Sys/20181212/4812889166006780509.png',
        '/upaiyun/Sys/20181212/5730019584033613388.png',
        '/upaiyun/Sys/20181212/5712446794891448386.png'
      ]
    }
  },
  components: { CourseImgsTemp },
  mounted () {
    setTimeout(() => { window.scrollTo(0, 0) }, 0)
  }
}
</script>
